import { connect } from 'react-redux';
import { compose, withState, withHandlers, withProps, withPropsOnChange } from 'recompose';
import sweetAlertConfirm from "../../../../components/enhancers/sweetAlertEnhancer";
import { intake, intakeEsl, programActualStartDate, eslActualStartDate, programAlternateActualStartDate, eslAlternateActualStartDate } from '@applyboard/ab-common';
import StartDates from "./StartDates";
import useInitialProps from "../../../../hooks/useInitialProps";
import { setIsInitialActualStartDatesAction, setSavedProgramIntakeStartDateAction } from "../../../../store/actions/application";
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var enhancer = compose(connect(function (state) {
  var _state$application;
  return {
    isInitialActualStartDates: (state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : _state$application.isInitialActualStartDates) || false
  };
}, {
  setIsInitialActualStartDates: setIsInitialActualStartDatesAction,
  setSavedProgramIntakeStartDate: setSavedProgramIntakeStartDateAction
}), withState('originalValues', 'setOriginalValues', function (_ref) {
  var application = _ref.application;
  return {
    academicId: application === null || application === void 0 ? void 0 : application.mainIntakeId,
    academic: intake(application),
    eslId: application === null || application === void 0 ? void 0 : application.eslIntakeId,
    esl: intakeEsl(application),
    eslActualStartDate: eslActualStartDate(application),
    programActualStartDate: programActualStartDate(application),
    eslAlternateActualStartDate: eslAlternateActualStartDate(application),
    programAlternateActualStartDate: programAlternateActualStartDate(application)
  };
}), withProps(function (_ref2) {
  var application = _ref2.application,
    originalValues = _ref2.originalValues;
  var statuses = application && application.status;
  var shouldShowIntakeStatus = statuses && !statuses.canceled && !statuses.withdrawn && !statuses.submitted;
  var _useInitialProps = useInitialProps(),
    internal_user_for_intake_status = _useInitialProps.internal_user_for_intake_status;
  return {
    dirty: originalValues.academic !== intake(application) || originalValues.esl !== intakeEsl(application) || originalValues.eslActualStartDate !== eslActualStartDate(application) || originalValues.programActualStartDate !== programActualStartDate(application) || originalValues.eslAlternateActualStartDate !== eslAlternateActualStartDate(application) || originalValues.programAlternateActualStartDate !== programAlternateActualStartDate(application),
    shouldShowIntakeStatus: shouldShowIntakeStatus,
    isInternalUserForIntake: internal_user_for_intake_status
  };
}), withPropsOnChange(['application'], function (_ref3) {
  var _application$status, _application$status2;
  var application = _ref3.application;
  return {
    eslActualStartDate: eslActualStartDate(application),
    programActualStartDate: programActualStartDate(application),
    eslAlternateActualStartDate: eslAlternateActualStartDate(application),
    programAlternateActualStartDate: programAlternateActualStartDate(application),
    readyForVisa: application === null || application === void 0 ? void 0 : (_application$status = application.status) === null || _application$status === void 0 ? void 0 : _application$status.ready_for_visa,
    deferralInProgress: application === null || application === void 0 ? void 0 : (_application$status2 = application.status) === null || _application$status2 === void 0 ? void 0 : _application$status2.deferral_in_progress
  };
}), withHandlers({
  onAcademicDateChange: function onAcademicDateChange(props) {
    return function (id, date) {
      var _props$application;
      props.onDateChange(id, date, (_props$application = props.application) === null || _props$application === void 0 ? void 0 : _props$application.eslIntakeId, intakeEsl(props.application), eslActualStartDate(props.application), programActualStartDate(props.application), eslAlternateActualStartDate(props.application), programAlternateActualStartDate(props.application));
      props.setIsInitialActualStartDates(false);
    };
  },
  onEslDateChange: function onEslDateChange(props) {
    return function (id, date) {
      var _props$application2;
      props.onDateChange((_props$application2 = props.application) === null || _props$application2 === void 0 ? void 0 : _props$application2.mainIntakeId, intake(props.application), id, date, eslActualStartDate(props.application), programActualStartDate(props.application), eslAlternateActualStartDate(props.application), programAlternateActualStartDate(props.application));
      props.setIsInitialActualStartDates(false);
    };
  },
  onEslActualStartDateChange: function onEslActualStartDateChange(props) {
    return function (event) {
      if (event && event.target) {
        var _props$application3, _props$application4;
        props.onDateChange((_props$application3 = props.application) === null || _props$application3 === void 0 ? void 0 : _props$application3.mainIntakeId, intake(props.application), (_props$application4 = props.application) === null || _props$application4 === void 0 ? void 0 : _props$application4.eslIntakeId, intakeEsl(props.application), event.target.value ? event.target.value.format('YYYY-MM-DD') : null, programActualStartDate(props.application), eslAlternateActualStartDate(props.application), programAlternateActualStartDate(props.application));
        props.setIsInitialActualStartDates(false);
      }
    };
  },
  onProgramActualStartDateChange: function onProgramActualStartDateChange(props) {
    return function (event) {
      if (event && event.target) {
        var _props$application5, _props$application6;
        props.onDateChange((_props$application5 = props.application) === null || _props$application5 === void 0 ? void 0 : _props$application5.mainIntakeId, intake(props.application), (_props$application6 = props.application) === null || _props$application6 === void 0 ? void 0 : _props$application6.eslIntakeId, intakeEsl(props.application), eslActualStartDate(props.application), event.target.value ? event.target.value.format('YYYY-MM-DD') : null, eslAlternateActualStartDate(props.application), programAlternateActualStartDate(props.application));
        props.setIsInitialActualStartDates(false);
      }
    };
  },
  onEslAlternateActualStartDateChange: function onEslAlternateActualStartDateChange(props) {
    return function (event) {
      if (event && event.target) {
        var _props$application7, _props$application8;
        props.onDateChange((_props$application7 = props.application) === null || _props$application7 === void 0 ? void 0 : _props$application7.mainIntakeId, intake(props.application), (_props$application8 = props.application) === null || _props$application8 === void 0 ? void 0 : _props$application8.eslIntakeId, intakeEsl(props.application), eslActualStartDate(props.application), programActualStartDate(props.application), event.target.value ? event.target.value.format('YYYY-MM-DD') : null, programAlternateActualStartDate(props.application));
        props.setIsInitialActualStartDates(false);
      }
    };
  },
  onProgramAlternateActualStartDateChange: function onProgramAlternateActualStartDateChange(props) {
    return function (event) {
      if (event && event.target) {
        var _props$application9, _props$application10;
        props.onDateChange((_props$application9 = props.application) === null || _props$application9 === void 0 ? void 0 : _props$application9.mainIntakeId, intake(props.application), (_props$application10 = props.application) === null || _props$application10 === void 0 ? void 0 : _props$application10.eslIntakeId, intakeEsl(props.application), eslActualStartDate(props.application), programActualStartDate(props.application), eslAlternateActualStartDate(props.application), event.target.value ? event.target.value.format('YYYY-MM-DD') : null);
        props.setIsInitialActualStartDates(false);
      }
    };
  },
  onSave: function onSave(_ref4) {
    var application = _ref4.application,
      onDateSave = _ref4.onDateSave,
      setOriginalValues = _ref4.setOriginalValues,
      setIsInitialActualStartDates = _ref4.setIsInitialActualStartDates,
      setSavedProgramIntakeStartDate = _ref4.setSavedProgramIntakeStartDate;
    return function () {
      return onDateSave().then(function () {
        setOriginalValues({
          academicId: application === null || application === void 0 ? void 0 : application.mainIntakeId,
          academic: intake(application),
          eslId: application === null || application === void 0 ? void 0 : application.eslIntakeId,
          esl: intakeEsl(application),
          eslActualStartDate: eslActualStartDate(application),
          programActualStartDate: programActualStartDate(application),
          eslAlternateActualStartDate: eslAlternateActualStartDate(application),
          programAlternateActualStartDate: programAlternateActualStartDate(application)
        });
        setIsInitialActualStartDates(true);
        setSavedProgramIntakeStartDate(application.intake);
      })["catch"](function () {});
    };
  }
}), sweetAlertConfirm('onSave'), withHandlers({
  resetOnSave: function resetOnSave(_ref5) {
    var cancelonSave = _ref5.cancelonSave,
      dirty = _ref5.dirty,
      setDirty = _ref5.setDirty,
      onDateChange = _ref5.onDateChange,
      originalValues = _ref5.originalValues;
    return function () {
      onDateChange(originalValues.academicId, originalValues.academic, originalValues.eslId, originalValues.esl, originalValues.eslActualStartDate, originalValues.programActualStartDate, originalValues.eslAlternateActualStartDate, originalValues.programAlternateActualStartDate);
      if (dirty) setDirty(false);
      cancelonSave();
    };
  }
}));
export default enhancer(StartDates);